import React from 'react';

import {
  widgetDefaultProps,
  widgetPropType,
} from '@glowforge/gf-styled/models';

import FeaturesDisplay from './features-display-rebrand';

// Used to map Contentful content to this custom widget. See
// ui-common/contentful-widgets/
const FeaturesDisplayWidget = ({ sections }) => {
  const {
    title: sectionTitle,
    delay,
    content,
  } = sections.find(
    (section) => section.fields.slug === 'features-list-homepage'
  )?.fields;

  // Coerce textAndImage sections into desired shape.
  const features = content?.map((feature) => {
    const { title, bodyContent, image, background } = feature.fields;
    const { fields: backgroundFields } = background;
    const backgroundImage = backgroundFields?.desktopImage?.fields?.file?.url;
    const colorFields = backgroundFields?.desktopColor?.fields;
    const backgroundColor = colorFields
      ? `${colorFields.hue}.${colorFields.tint}`
      : 'magic.base'; // default to magic.base in absence of background.

    return {
      title,
      bodyContent,
      image,
      backgroundImage,
      backgroundColor,
    };
  });

  return (
    <FeaturesDisplay
      delay={delay}
      features={features}
      sectionTitle={sectionTitle}
    />
  );
};

FeaturesDisplayWidget.propTypes = widgetPropType;

FeaturesDisplayWidget.defaultProps = widgetDefaultProps;

export default FeaturesDisplayWidget;
